import { Phone, Mail, MapPin, Linkedin } from "lucide-react";

const footerLinks = {
  empresa: [
    { label: "Inicio", href: "#hero" },
    { label: "Nosotros", href: "#about" },
    { label: "Certificaciones", href: "#quality" },
    { label: "Contacto", href: "#contact" },
  ],
  soluciones: [
    { label: "Construcción Eléctrica", href: "#services" },
    { label: "Ingeniería Especializada (EPC)", href: "#services" },
    { label: "Infraestructura Tecnológica", href: "#services" },
    { label: "Logística Técnica y Transporte", href: "#services" },
    { label: "Alquiler de Equipos", href: "#services" },
  ],
};

export default function Footer() {
  return (
    <footer id="footer" className="bg-slate-950 border-t border-slate-800">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="lg:col-span-1">
            <a href="#hero" className="flex items-center mb-5">
              <img
                src="/images/logo.png"
                alt="NOR Obras"
                className="h-10 brightness-0 invert"
              />
            </a>
            <p className="text-slate-500 text-sm leading-relaxed mb-6">
              Ingeniería eléctrica e industrial con más de 18 años de experiencia en proyectos de alta complejidad.
            </p>
            {/* Social */}
            <div className="flex gap-3">
              <a
                href="https://www.linkedin.com/company/nor-obras/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="LinkedIn"
                className="w-9 h-9 bg-slate-800 hover:bg-orange-500 border border-slate-700 hover:border-orange-500 rounded flex items-center justify-center text-slate-400 hover:text-white transition-all duration-200"
              >
                <Linkedin size={15} />
              </a>
            </div>
          </div>

          {/* Empresa */}
          <div>
            <h4 className="text-white font-bold text-sm uppercase tracking-widest mb-5">
              Empresa
            </h4>
            <ul className="space-y-3">
              {footerLinks.empresa.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="text-slate-500 hover:text-orange-400 text-sm transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Soluciones */}
          <div>
            <h4 className="text-white font-bold text-sm uppercase tracking-widest mb-5">
              Soluciones
            </h4>
            <ul className="space-y-3">
              {footerLinks.soluciones.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="text-slate-500 hover:text-orange-400 text-sm transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contacto */}
          <div>
            <h4 className="text-white font-bold text-sm uppercase tracking-widest mb-5">
              Contacto
            </h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <MapPin className="text-orange-500 flex-shrink-0 mt-0.5" size={16} />
                <span className="text-slate-500 text-sm">
                  El Cebil N° 417, B° Chijra<br />
                  San Salvador de Jujuy - Argentina
                </span>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="text-orange-500 flex-shrink-0" size={16} />
                <a
                  href="tel:+543884801994"
                  className="text-slate-500 hover:text-orange-400 text-sm transition-colors"
                >
                  +54 388 4801994
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="text-orange-500 flex-shrink-0" size={16} />
                <a
                  href="mailto:contacto@norobras.com"
                  className="text-slate-500 hover:text-orange-400 text-sm transition-colors"
                >
                  contacto@norobras.com
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-slate-800 py-5">
        <div className="max-w-7xl mx-auto px-6 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-slate-600">
          <p>© {new Date().getFullYear()} Nor Obras. Todos los derechos reservados.</p>
          <p>Ingeniería Industrial · Construcción Eléctrica · Infraestructura Tecnológica</p>
        </div>
      </div>
    </footer>
  );
}
